var React = require('react');

function DecoyTraffic (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Decoy Traffic"},React.createElement("path",{"id":"Union","fillRule":"evenodd","clipRule":"evenodd","d":"M26 20C29.866 20 33 16.866 33 13C33 9.13401 29.866 6 26 6C22.134 6 19 9.13401 19 13C19 16.866 22.134 20 26 20ZM36.3196 16.8174C35.7845 18.2632 34.9544 19.5658 33.9022 20.6521C35.9547 21.3254 38.1789 22.5884 40.1609 24.7475C43.5341 28.4222 46 34.464 46 44C46 45.1046 45.1046 46 44 46C42.8954 46 42 45.1046 42 44C42 35.136 39.7159 30.1778 37.2141 27.4525C34.7028 24.7167 31.764 24 30 24H26H6V44C6 45.1046 5.10457 46 4 46C2.89543 46 2 45.1046 2 44V22V20H4H17.5143C15.9436 18.0981 15 15.6593 15 13C15 6.92487 19.9249 2 26 2C30.733 2 34.7678 4.98915 36.3196 9.1826L43 13L36.3196 16.8174Z","fill":"#8D6CFF"})));
}

DecoyTraffic.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = DecoyTraffic;

DecoyTraffic.default = DecoyTraffic;
